import { Check } from "lucide-react";
import { CategoryIcon } from "@/components/progress";

// DeedCarousel - Zeigt alle 3 Taten zur Auswahl
const DeedCarousel = ({
  dailyDeeds,
  currentDeedIndex,
  displayDate,
  formatDate,
  isRamadanActive,
  t,
  onSelectDeed,
  onDeedClick
}) => {
  return (
    <div 
      className="deed-carousel-container selection-mode"
      data-testid="deed-carousel"
    >
      {/* Auswahl-Titel */}
      <div className="selection-title" data-testid="selection-title">
        {t.chooseDeed || "Wähle deine Tat für heute"}
      </div>
      
      {/* Datum */}
      <div className="selection-date" data-testid="selection-date">
        {formatDate(displayDate)}
      </div>
      
      {/* Alle 3 Taten als Karten */}
      <div className="deed-options-container">
        {dailyDeeds.map((deed, index) => (
          <div 
            key={index}
            className={`deed-option-card ${index === currentDeedIndex ? 'selected' : ''}`}
            onClick={() => onDeedClick(index)}
            data-testid={`deed-option-${index}`}
          >
            {/* Ausgewählt-Indikator */}
            {index === currentDeedIndex && (
              <div className="deed-selected-indicator">
                <Check size={14} />
              </div>
            )}
            
            {/* Kategorie-Icon */}
            <div className="deed-option-icon">
              <CategoryIcon category={deed.category} size={20} />
            </div>
            
            {/* Tat-Text */}
            <p className="deed-option-text">
              {deed.text}
            </p>
            
            {/* Quelle */}
            <span className="deed-option-source">
              {deed.source}
            </span>
          </div>
        ))}
      </div>
      
      {/* Bestätigen-Button */}
      <button
        className={`action-btn select-btn ${isRamadanActive ? 'ramadan-btn' : ''}`}
        onClick={onSelectDeed}
        data-testid="select-button"
      >
        {t.confirmDeed || "Tat bestätigen"}
      </button>
    </div>
  );
};

export default DeedCarousel;
